export default {
  startingPitchers: {
    title: "Starting Pitchers",
    tabs: {
      byPitcher: "By Pitcher",
      allPitchers: "All Pitchers",
    },
    labels: {
      confirmed: "CONFIRMED",
      expected: "EXPECTED",
      pitcher: "PITCHER",
      tbd: "TBD",
    },
    empty: {
      title: "No starting pitchers available",
    },
  },
};